export const createRefinedSelectedOptions = (
  options: any,
  selectedValues: any,
) =>
  options
    .filter((obj: any) => {
      return (
        selectedValues
          .map((value: { id: string }) => value.id)
          .indexOf(obj.id) >= 0
      )
    })
    .map((option: any) => ({
      id: option.id,
      name: option.name,
      type: option.type,
    }))
